import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {SpecialistEnums} from '@namespaces/specialist.namespace';
import {SelectValueInterface} from '@interfaces/select-value.interface';

@Injectable()
export class PermitTypesProvider {
    public data$ = new BehaviorSubject<SelectValueInterface[]>([
        {id: SpecialistEnums.PermitType.fireTechMin, title: 'Пожарно-технический минимум'},
        {id: SpecialistEnums.PermitType.workingOnHigh, title: 'Допуск работы на высоте'},
        {id: SpecialistEnums.PermitType.labourProtection, title: 'Обучение по охране труда'},
        {id: SpecialistEnums.PermitType.electrosecurityLabourProtection, title: 'Аттестация инженера по ОТ по электробезопасности'},
        {id: SpecialistEnums.PermitType.electrosecurityAccess, title: 'Группы допуска по электробезопасности'},
        {id: SpecialistEnums.PermitType.radiationSafety, title: 'Обучение на знание правил радиационной безопасности (72 часа)'},
        {id: SpecialistEnums.PermitType.liftWorker, title: 'Рабочий люльки подъёмника (вышки)'},
    ]);
}
